// extracted by mini-css-extract-plugin
export var container = "style-module--container--a215d";
export var large = "style-module--large--9de4a";
export var wideChildren = "style-module--wideChildren--0359d";
export var wideTitle = "style-module--wideTitle--92a2b";